module.exports = __webpack_public_path__ + "media/stylesheets/images/icon/check-3a92e5a6df099108fc9836e19a029177.svg";